/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react"; //import the component part of React
import withRouter from "../WithRouter";
// Common
import FadeIn from "../common/FadeIn";
import ReturnButton from "../common/ReturnButton";
//Packages
import axios from "axios";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { isAuthenticatedCustomer } from "./services/CustomerAuth"; //import auth

const ParticipantAwards = (props) => {
  // State
  const [participant, setParticipant] = useState("");
  const [awards, setAwards] = useState([]);
  // Props and Refs
  const participantid = props.params.participantid;
  const prevParticipantid = useRef();
  useEffect(async () => {
    prevParticipantid.current = participantid; // Update if ID changes.
    const participantAwardsGet = await axios.get(
      `/api/customer/customer_general/participant_awards_view/${participantid}`,
      {
        withCredentials: true,
      }
    );

    const subject = participantAwardsGet.data.Participants[0];

    setParticipant(subject);
    return setAwards(subject.Awards);
  }, [participantid]);
  return (
    <div className='awards'>
      <FadeIn delay={250} duration={450}>
        {!isAuthenticatedCustomer() && <Navigate to='/login/' />}
        <Container>
          <Row className='text-center'>
            <Col>
              <ReturnButton />
              <h3>{`${participant.First_Name}'s Awards`}</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              {awards.map((award) => (
                <div key={award._id} className='mx-1 mt-3 p-2 shadow text-center border'>
                  <h4>{award.Type}</h4>
                  <p className='smallprint'>{award.ShortDescription}</p>
                  {award.AwardURL.length > 10 && (
                    <a href={award.AwardURL}>
                      <Button type='link' variant='secondary' className='mt-3 mb-3 w-100'>
                        Buy
                      </Button>
                    </a>
                  )}
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </FadeIn>
    </div>
  );
};

export default withRouter(ParticipantAwards);
